import React, { useEffect, useState } from "react";
import Switch from "react-switch";
import { Gmail, SMS, Whatsapp } from "../../icons";
import { useSelector } from "react-redux";
import { Notification } from "../../services/btc-api.service";
import { initUserSession } from "../../services/auth.service";


const CustomSwitch = ({ checked, onChange, className }) => {
  return (
    <Switch
      className={className}
      checked={checked}
      onChange={onChange}
      checkedIcon={false}
      uncheckedIcon={false}
    />
  );
};

export default function NotificationSettings() {
  const user = useSelector((state) => state.user.user);
  const [notificationSettings, setNotificationSettings] = useState({
    email: false,
    whatsapp: false,
    sms: false,
  });

  useEffect(() => {
    fetchNotificationSettings();
  }, []);

  const fetchNotificationSettings = async () => {
    try {
      setNotificationSettings(user.notification);
    } catch (error) {
      console.error("Error fetching notification settings:", error);
    }
  };

  const handleNotificationChange = (notificationType) => async (checked) => {
    setNotificationSettings((prevSettings) => ({
      ...prevSettings,
      [notificationType]: checked,
    }));

    try {
      await Notification({
        userId: user._id,
        settings: {
          [notificationType]: checked,
        },
      });

      initUserSession()
    } catch (error) {
      console.error("Error updating notification settings:", error);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center" style={{ marginTop: 100 }}>
        <div className="notificationSettings">
          {" "}
          <div className="iconTextStyle">
            <Gmail className="iconStyleNotification" /> &nbsp;&nbsp;&nbsp; G
            Mail NOTIFICATION
          </div>
          <span className="customSwitchStyle">
            <CustomSwitch
              className={"styleswitch"}
              checked={notificationSettings.email}
              onChange={handleNotificationChange("email")}
            />
          </span>
        </div>
      </div>
      <div className="row justify-content-center mt-2">
        <div className="notificationSettings">
          {" "}
          <div className="iconTextStyle">
            <Whatsapp className="iconStyleNotification" /> &nbsp;&nbsp;&nbsp;
            WHATSAPP NOTIFICATION
          </div>
          <span className="customSwitchStyle">
            <CustomSwitch
              className={"styleswitch"}
              checked={notificationSettings.whatsapp}
              onChange={handleNotificationChange("whatsapp")}
            />
          </span>
        </div>
      </div>
      <div className="row justify-content-center mt-2">
        <div className="notificationSettings">
          {" "}
          <div className="iconTextStyle">
            <SMS className="iconStyleNotification" /> &nbsp;&nbsp;&nbsp; SMS
            NOTIFICATION
          </div>
          <span className="customSwitchStyle">
            <CustomSwitch
              className={"styleswitch"}
              checked={notificationSettings.sms}
              onChange={handleNotificationChange("sms")}
            />
          </span>
        </div>
      </div>
      <div style={{ marginBottom: 200 }}></div>
    </div>
  );
}
